import { render } from "./Department.vue?vue&type=template&id=17e6eabb&scoped=true"
import script from "./Department.vue?vue&type=script&lang=js"
export * from "./Department.vue?vue&type=script&lang=js"

import "./Department.vue?vue&type=style&index=0&id=17e6eabb&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ardent_dms_v2\\ardent_dms\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17e6eabb"]])

export default __exports__